<form class="no-borders" >

  <div class="mb-4" [formGroup]="referralAgencyForm">
    <div class="card">
      <div class="card-header"><b>Referral Agency</b></div>
      <div class="card-body px-2 form-group mb-0">
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Referral Agency
          </label>
          <select class="form-control col-12 col-md-4"
                  formControlName="referralAgency"
                  required>
            <option *ngFor="let req of referralAgencies" [value]="req">
              {{
                req
              }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-4" [formGroup]="companyDescriptionForm">
    <div class="card">
      <div class="card-header"><b>COMPANY DESCRIPTION/BACKGROUND</b></div>
      <div class="card-body px-2 form-group mb-0">
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Primary Company Activity:
          </label>

          <select class="form-control col-12 col-md-4"
                  formControlName="primaryActivity"
                  (ngModelChange)="changePrimaryActivity($event)"
                  required>
            <option *ngFor="let req of primaryActivityTypes" [value]="req">
              {{
                req
              }}
            </option>
          </select>
        </div>
        <div *ngIf="isOtherPrimaryActivity" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            If Other, please specify:
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="primaryActivityDescription" name="primaryActivityDescription" rows="1"></textarea>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Primary Industry Affiliation (Select all that apply):
          </label>
          <div class="col-12 col-md-6 px-0">
            <step-primary-affiliation-multiselect class="multi-select" [selectedValues]="this.stepApplication.primaryAffiliation" (change)="changePrimaryAffiliation($event)" formControlName="primaryAffiliation"></step-primary-affiliation-multiselect>
          </div>
        </div>
        <div *ngIf="isOtherPrimaryAffiliation" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            If Other, please specify:
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="primaryAffiliationDescription" name="primaryAffiliationDescription" rows="1"></textarea>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Primary NAICS Code (<a class="font-weight-normal" href="https://www.census.gov/naics/" target="_blank" rel="noreferrer noopener">NAICS Code List</a>):
          </label>

          <input type="number" class="form-control col-12 col-md-6" max="999999" min="000000" (keypress)="preventNonNumeric($event)" pattern="^[0-9]{6}$" formControlName="naicsCode">
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Year Company Established:
          </label>

          <input type="number" class="form-control col-12 col-md-6" max="9999" min="0000" (keypress)="preventNonNumeric($event)" pattern="^\d{4}$" formControlName="yearEst">
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Do any of the following apply to your business (Select all that apply)?
          </label>
          <div class="col-12 col-md-6 px-0">
            <step-business-type-multiselect class="multi-select"  [selectedValues]="this.stepApplication.businessType" (change)="changeBusinessType($event)" formControlName="businessType" ></step-business-type-multiselect>
          </div>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Total # of Employees:
          </label>

          <input type="number" class="form-control col-12 col-md-6" (keypress)="preventNonNumeric($event)" formControlName="totalEmployees">
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Is the company a for-profit entity?
          </label>

          <fl-required-wrapper [value]="this.stepApplication.forProfit">
            <label class="form-check-inline">
              <input type="radio" [value]="true" formControlName="forProfit" />&nbsp;Yes
            </label>
            <label class="form-check-inline">
              <input type="radio" [value]="false" formControlName="forProfit" />&nbsp;No
            </label>
          </fl-required-wrapper>

        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Approximate Gross Sales Last Year:
          </label>

          <select class="form-control col-12 col-md-4"
                  formControlName="estGrossSalesLastYear"
                  required>
            <option *ngFor="let req of approxGrossSales" [value]="req">
              {{
                req
              }}
            </option>
          </select>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Does the company have an existing export plan or strategy?
          </label>

          <fl-required-wrapper [value]="this.stepApplication.existingExportStrategy">
            <label class="form-check-inline">
              <input type="radio" [value]="true" formControlName="existingExportStrategy" />&nbsp;Yes
            </label>
            <label class="form-check-inline">
              <input type="radio" [value]="false" formControlName="existingExportStrategy" />&nbsp;No
            </label>
          </fl-required-wrapper>

        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Approximate percentage of annual export sales last year:
          </label>

          <select class="form-control col-12 col-md-4"
                  formControlName="estAnnualExportPercentage"
                  required>
            <option *ngFor="let req of approxPercentageExport" [value]="req">
              {{
                req
              }}
            </option>
          </select>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Based on your export strategy, which international markets do you see as the next opportunity and the most potential for expanding your exports?
          </label>
          <div class="col-12 col-md-6 px-0">
            <div class="multiselect-dropdown-container">
              <ng-multiselect-dropdown class="multi-select" [placeholder]="'Select all that apply'"
                                       formControlName="exportLocation"
                                       [data]="exportLocationOptions"
                                       [settings]="dropdownSettings">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div *ngIf="showExportLocationOtherDescription()" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">

          </label>
          <textarea class="form-control col-12 col-md-6"
                    placeholder="Please List Other Export Locations"
                    formControlName="exportLocationOtherDescription"
                    name="exportLocationOtherDescription" rows="2"></textarea>
        </div>

        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Where else are you interested in exporting?
          </label>
          <div class="col-12 col-md-6 px-0">
            <div class="multiselect-dropdown-container">
              <ng-multiselect-dropdown class="multi-select" [placeholder]="'Select all that apply'"
                                       formControlName="exportLocationInterest"
                                       [data]="exportLocationOptions"
                                       [settings]="dropdownSettings">
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>

        <div *ngIf="showExportLocationInterestOtherDescription()" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">

          </label>
          <textarea class="form-control col-12 col-md-6"
                    placeholder="Please List Other Export Interest Locations"
                    formControlName="exportLocationInterestOtherDescription"
                    name="exportLocationInterestOtherDescription" rows="2"></textarea>
        </div>


      </div>
    </div>
  </div>

  <div class="mb-4" [formGroup]="productInformationForm">
    <div class="card pb-4">
      <div class="card-header"><b>PRODUCT/SERVICE INFORMATION</b></div>
      <div class="card-body px-2 form-group mb-0">
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Provide a brief/non-technical description of the company's products/services you seek to promote:
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="productDescription" name="productDescription" rows="2"></textarea>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            What are the various sales channels (Direct, Agents, Resellers, Distributors, Consultants...) through which your product/service reaches both domestic and international customers?
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="salesChannelsDescription" name="salesChannelsDescription" rows="2"></textarea>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Has your product/service been certified to meet domestic or international standards (I.E. CE, CCC, ETC.)?
          </label>

          <fl-required-wrapper [value]="this.stepApplication.isProductCertified">
            <label class="form-check-inline">
              <input type="radio" [value]="true" formControlName="isProductCertified" />&nbsp;Yes
            </label>
            <label class="form-check-inline">
              <input type="radio" [value]="false" formControlName="isProductCertified" />&nbsp;No
            </label>
          </fl-required-wrapper>

        </div>
        <div *ngIf="productInformationForm.controls['isProductCertified'].value" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            If so, please elaborate:
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="productCertifiedDescription" name="productCertifiedDescription" rows="2"></textarea>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Are you currently represented in any foreign country?
          </label>

          <fl-required-wrapper [value]="this.stepApplication.isForeignRepresentation">
            <label class="form-check-inline">
              <input type="radio" [value]="true" formControlName="isForeignRepresentation" />&nbsp;Yes
            </label>
            <label class="form-check-inline">
              <input type="radio" [value]="false" formControlName="isForeignRepresentation" />&nbsp;No
            </label>
          </fl-required-wrapper>

        </div>
        <div *ngIf="productInformationForm.controls['isForeignRepresentation'].value" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            If yes, which country? How are you represented <br /> (I.E. Sales Representative, Agent, Local Partners or Distributors, Strategic Alliances or Joint Ventures, Contract Manufacturing, Licensing or Franchising, or Office location.)?

          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="foreignRepresentationDescription" name="foreignRepresentationDescription" rows="2"></textarea>
        </div>

        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Is the company seeking to export goods or services that are of U.S. origin or have at least 51% U.S. content?
          </label>

          <fl-required-wrapper [value]="this.stepApplication.isExportUSOrigin">
            <label class="form-check-inline">
              <input type="radio" [value]="true" formControlName="isExportUSOrigin" />&nbsp;Yes
            </label>
            <label class="form-check-inline">
              <input type="radio" [value]="false" formControlName="isExportUSOrigin" />&nbsp;No
            </label>
          </fl-required-wrapper>

        </div>

        <div *ngIf="productInformationForm.controls['isExportUSOrigin'].value" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            If yes, please identify your contact.<br />
            <b>U.S. content or manufactured goods</b> = (ex-factory price of
            a good) minus (aggregate value contributed by non-U.S. or
            foreign sources (e.g., costs or payments to foreign suppliers/providers/employees
            not resident in the United States)).
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="usOriginContact" name="usOriginContact" rows="2"></textarea>
        </div>

        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            Describe any other state or federal organizations with which you have or are currently working (Select all that apply):
          </label>
          <div class="col-12 col-md-6 px-0">
            <step-other-orgs-multiselect class="multi-select" [selectedValues]="this.stepApplication.otherOrgs" (change)="changeOtherOrgs($event)" formControlName="otherOrgs"></step-other-orgs-multiselect>
          </div>
        </div>
        <div *ngIf="isOtherFederalOrg" class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            If Other, please specify:
          </label>
          <textarea class="form-control col-12 col-md-6" formControlName="otherOrgsDescription" name="otherOrgsDescription" rows="1"></textarea>
        </div>
        <div class="row d-flex align-items-center py-2 px-5">
          <label class="form-control-label col-12 col-md-6">
            The US Small Business Administration (SBA) would like to give eligible small business concerns the opportunity to expand your
            knowledge and resources of other programs that are offered by the agency. Please check the appropriate box if you would like for your
            company’s name and contact information to be shared with other programs offered by SBA. Your choice to participate or not, will not
            change the status of your participation with STEP. SBA’s aim is strictly to share information about other opportunities with you:
          </label>

          <fl-required-wrapper [value]="this.stepApplication.optInSBA">
            <label class="form-check-inline">
              <input type="radio" [value]="true" formControlName="optInSBA" />&nbsp;Yes
            </label>
            <label class="form-check-inline">
              <input type="radio" [value]="false" formControlName="optInSBA" />&nbsp;No
            </label>
          </fl-required-wrapper>

        </div>
      </div>
    </div>
  </div>

  <div class="mb-4" [formGroup]="stepApplicationForm">
    <div class="card">
      <div class="card-header"><b>PLANNED USE OF STEP FUNDS</b></div>
      <div class="card-body px-5 form-group mb-0">
        Please indicate your intended use of STEP funds including dates of activity:
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-12">
            <input type="checkbox" formControlName="tradeShowsAndMissions" /> Travel and participation in domestic and overseas trade shows & missions (includes virtual)
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['tradeShowsAndMissions'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate shows or missions you plan to attend: <br />
          Activity Name: <br />
          City and Country Location: <br />
          Date(s) of activity: <br />
          Personnel attending:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="tradeShowsAndMissionsDescription" name="tradeShowsAndMissionsDescription" rows="4"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="globalMarketEvents" /> Travel and participation in global market events or similar federal programs (includes virtual)
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['globalMarketEvents'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate events you are interested in attending:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="globalMarketEventsDescription" name="globalMarketEventsDescription" rows="1"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="usCommercialServices" /> US commercial service fee services
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['usCommercialServices'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate which services:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="usCommercialServicesDescription" name="usCommercialServicesDescription" rows="1"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="exportWorkshops" /> Export training workshops (includes virtual)
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['exportWorkshops'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate events you are interested in attending:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="exportWorkshopsDescription" name="exportWorkshopsDescription" rows="1"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="ecommAndWebGlobalization" /> E-commerce and website globalization
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['ecommAndWebGlobalization'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate anticipated services:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="ecommAndWebGlobalizationDescription" name="ecommAndWebGlobalizationDescription" rows="1"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="designMarketingMedia" /> Design of marketing media
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['designMarketingMedia'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate anticipated services:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="designMarketingMediaDescription" name="designMarketingMediaDescription" rows="1"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="complianceTestingAndShipping" /> Compliance testing and shipping of sample products
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['complianceTestingAndShipping'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate anticipated activities:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="complianceTestingAndShippingDescription" name="complianceTestingAndShippingDescription" rows="1"></textarea>
      </div>
      <div class="card-body px-5 form-group mb-0">
        <div class="row d-flex align-items-center px-5">
          <label class="form-control-label col-12 col-md-6">
            <input type="checkbox" formControlName="otherExpenseOrActivity" /> Other expenses or activities
          </label>
        </div>
      </div>
      <div *ngIf="stepApplicationForm.controls['otherExpenseOrActivity'].value" class="card-body d-flex align-items-center py-2 px-5 ml-5">
        <label class="form-control-label col-12 col-md-6">
          Please indicate other activities or expenses:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="otherExpenseOrActivityDescription" name="otherExpenseOrActivityDescription" rows="1"></textarea>
      </div>
      <div class="row d-flex align-items-center py-4 px-5">
        <label class="form-control-label col-12 col-md-6">
          Please tell us how you heard about the STEP Grant Program:
        </label>
        <textarea class="form-control col-12 col-md-6" formControlName="heardAboutDescription" name="heardAboutDescription" rows="3"></textarea>
      </div>

      <div class="row d-flex align-items-center py-4 px-5">
        <span class="col-12">
          This program is supported by federal funding through the U.S. Small Business Administration. Full disclosure is available at
          <a href="https://www.opportunitylouisiana.gov/program/step-grant"
              target="_blank"
              aria-label="Link to STEP Grant Program"
              referrerpolicy="no-referrer">
            www.opportunitylouisiana.gov/program/step-grant
          </a>.
        </span>

      </div>
    </div>
  </div>

  <!-- TEMPLATE TO USE FOR DISPLAYING THE LEGEND -->
  <div #careerInfoTemplate class="d-none">
    <div style="z-index: 50000" class="popover" role="tooltip">
      <div class="arrow"></div>
      <h3 class="popover-header"></h3>
      <div class="popover-body"></div>
    </div>
  </div>
</form>
